import React from 'react';
import { useTranslation } from 'react-i18next';
import { tr } from '../../../i18n/msg';
import { rewardLabel } from '../../../shared/utils/gameLabels';

export default function RewardModal({ reward, onClose, onConfirm, onSecondary }) {
  const { t } = useTranslation();
  if (!reward) return null;
  const { label, icon, text, quantity } = mapRewardToView(reward, t);

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">{t('reward.congratulations', 'Congratulations!')}</h2>
        <div className="modal-reward-image-wrapper">
          <div className="modal-shine-background">
            <div className="rotating-burst-mask">
              <div className="rotating-burst" />
            </div>
          </div>
          <img src={icon} alt={label} className="modal-reward-image" />
        </div>
        <h3 className="modal-reward-label">{label}</h3>
        {quantity ? <p className="modal-reward-quantity">{quantity}</p> : null}
        {text ? <p className="modal-text">{text}</p> : null}
        <button className="app-btn app-btn--green" onClick={onConfirm || onClose}>{t('common.ok', 'OK')}</button>
        {/* Optional follow-up action (e.g. "Open another" chest) — also plays the fly animation */}
        {reward.secondaryAction && onSecondary ? (
          <button className="app-btn app-btn--purple modal-secondary-btn" onClick={onSecondary}>
            {reward.secondaryAction.labelMsg ? tr(t, reward.secondaryAction.labelMsg) : reward.secondaryAction.label}
          </button>
        ) : null}
      </div>
    </div>
  );
}

function mapRewardToView(reward, t) {
  const label = reward.text || rewardLabel(t, reward);

  let icon = reward.icon;
  if (reward.type === 'MODULE' && reward.moduleData?.urlSmall) {
    icon = reward.moduleData.urlSmall;
  }
  if (reward.type === 'CHEST') {
    icon = reward.chestImageUrl || icon;
  }
  if (reward.type === 'KEY') {
    icon = reward.keyImageUrl || icon;
  }
  if (!icon) {
    icon = defaultIcon(reward.type);
  }

  // Format quantity: hide for MODULE (x1 isn't meaningful), show for currency / lootbox
  let quantity = null;
  const val = Number(reward.value);
  if (reward.type === 'CHEST' || reward.type === 'KEY') {
    if (val > 0) quantity = `x${val}`;
  } else if (reward.type !== 'MODULE' && val > 0) {
    if (reward.type === 'TON') {
      quantity = `+${val} GRAM`;
    } else {
      quantity = `+${val.toLocaleString()}`;
    }
  } else if (reward.type === 'MODULE' && val > 1) {
    quantity = `x${val}`;
  }

  return { label, icon, text: reward.textOverride, quantity };
}

function defaultIcon(type) {
  switch (type) {
    case 'COINS': return 'slider/coins_1.png';
    case 'TICKETS': return '/ticket_icon.png';
    case 'TON': return 'slider/ton.png';
    case 'MODULE': return 'slider/eagle_head.png';
    case 'CHEST': return '/lootbox/icon_chest_green.png';
    case 'KEY': return '/lootbox/icon_key_green.png';
    case 'LIVES': return '/lair/heart.svg';
    default: return 'slider/coins_1.png';
  }
}


